import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem', gap: '1.5rem' },
  header: { display: 'flex', alignItems: 'center', gap: '1rem', width: '100%', maxWidth: '800px' },
  back: { background: 'rgba(255,255,255,0.1)', color: 'white', borderRadius: '12px', padding: '0.5rem 1rem', fontSize: '1.2rem', border: 'none', cursor: 'pointer' },
  xpRow: { display: 'flex', gap: '1rem', fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: 700 },
  tabs: { display: 'flex', gap: '0.75rem', background: 'rgba(0,0,0,0.3)', padding: '0.5rem', borderRadius: '16px' },
  card: { background: 'rgba(13,27,42,0.8)', border: '2px solid rgba(0,245,160,0.2)', borderRadius: '24px', padding: '2rem', width: '100%', maxWidth: '1000px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem' },
  nextBtn: { background: 'var(--green)', color: '#060b14', borderRadius: '16px', padding: '0.9rem 2rem', fontSize: '1.1rem', fontWeight: 900, border: 'none', cursor: 'pointer' },
  xpFloat: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', fontSize: '3rem', fontFamily: 'Bangers, cursive', color: 'var(--green)', pointerEvents: 'none', animation: 'xpPop 1s ease forwards', zIndex: 9999 },
  optionGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem', width: '100%' },
};

function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2-lat1)*Math.PI/180;
  const dLng = (lng2-lng1)*Math.PI/180;
  const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLng/2)**2;
  return R*2*Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function OptionBtn({ label, state, onClick }) {
  return (
    <button onClick={onClick} style={{
      background: state === 'correct' ? 'rgba(0,245,160,0.2)' : state === 'wrong' ? 'rgba(255,77,109,0.2)' : 'rgba(255,255,255,0.05)',
      border: '2px solid '+(state === 'correct' ? 'var(--green)' : state === 'wrong' ? 'var(--red)' : 'rgba(255,255,255,0.1)'),
      borderRadius: '14px', padding: '0.8rem', fontSize: '0.95rem', fontWeight: 800, color: 'white',
      cursor: state ? 'default' : 'pointer', transition: 'all 0.2s', textAlign: 'center',
      boxShadow: state === 'correct' ? '0 0 15px rgba(0,245,160,0.3)' : 'none'
    }}>{label}</button>
  );
}

function FlagMode({ onCorrect }) {
  const [data, setData] = useState(null);
  const [chosen, setChosen] = useState(null);
  useEffect(() => { load(); }, []);

  const load = async () => {
    setData(null); setChosen(null);
    const r = await fetch('/api/geo/flag');
    setData(await r.json());
  };

  const pick = (opt) => {
    if (chosen) return;
    setChosen(opt);
    if (opt === data.answer) onCorrect(3);
  };

  if (!data) return <div style={{ color: 'var(--text-muted)', padding: '2rem' }}>Henter flag...</div>;

  return (
    <>
      <img src={'https://flagcdn.com/w320/'+data.flag.toLowerCase()+'.png'} alt={data.answer} style={{ width: '280px', height: 'auto', borderRadius: '8px', boxShadow: '0 8px 32px rgba(0,0,0,0.6)' }} />
      <div style={{ color: 'var(--text-muted)', fontWeight: 700, fontSize: '1.1rem' }}>Hvilket land er dette?</div>
      <div style={s.optionGrid}>
        {data.options.map(opt => {
          const state = chosen ? (opt === data.answer ? 'correct' : opt === chosen ? 'wrong' : null) : null;
          return <OptionBtn key={opt} label={opt} state={state} onClick={() => pick(opt)} />;
        })}
      </div>
      {chosen && (
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
          <div style={{ fontSize: '1.8rem', fontFamily: 'Bangers, cursive', color: chosen === data.answer ? 'var(--green)' : 'var(--red)', letterSpacing: '2px' }}>
            {chosen === data.answer ? '🎉 Rigtigt! +3 XP' : '❌ Det var '+data.answer}
          </div>
          <button style={s.nextBtn} onClick={load}>Næste flag →</button>
        </div>
      )}
    </>
  );
}

function CapitalMode({ onCorrect }) {
  const [data, setData] = useState(null);
  const [chosen, setChosen] = useState(null);
  useEffect(() => { load(); }, []);

  const load = async () => {
    setData(null); setChosen(null);
    const r = await fetch('/api/geo/capital');
    setData(await r.json());
  };

  const pick = (opt) => {
    if (chosen) return;
    setChosen(opt);
    if (opt === data.answer) onCorrect(3);
  };

  if (!data) return <div style={{ color: 'var(--text-muted)', padding: '2rem' }}>Henter spørgsmål...</div>;

  return (
    <>
      <div style={{ fontFamily: 'Bangers, cursive', fontSize: '3.5rem', color: 'var(--green)', letterSpacing: '3px', textAlign: 'center', textShadow: '0 0 20px rgba(0,245,160,0.4)' }}>{data.country}</div>
      <div style={{ color: 'var(--text-muted)', fontWeight: 700, fontSize: '1.1rem' }}>Hvad er hovedstaden?</div>
      <div style={s.optionGrid}>
        {data.options.map(opt => {
          const state = chosen ? (opt === data.answer ? 'correct' : opt === chosen ? 'wrong' : null) : null;
          return <OptionBtn key={opt} label={opt} state={state} onClick={() => pick(opt)} />;
        })}
      </div>
      {chosen && (
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
          <div style={{ fontSize: '1.8rem', fontFamily: 'Bangers, cursive', color: chosen === data.answer ? 'var(--green)' : 'var(--red)', letterSpacing: '2px' }}>
            {chosen === data.answer ? '🎉 Rigtigt! +3 XP' : '❌ Det var '+data.answer}
          </div>
          <button style={s.nextBtn} onClick={load}>Næste →</button>
        </div>
      )}
    </>
  );
}

function MapMode({ onCorrect }) {
  const [data, setData] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [distance, setDistance] = useState(null);
  const [pts, setPts] = useState(null);
  const mapRef = React.useRef(null);
  const leafletMap = React.useRef(null);
  const markersRef = React.useRef([]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = () => loadNew();
    document.head.appendChild(script);
    return () => { if (leafletMap.current) { leafletMap.current.remove(); leafletMap.current = null; } };
  }, []);

  const loadNew = async () => {
    setClicked(false); setDistance(null); setPts(null);
    markersRef.current.forEach(m => { try { m.remove(); } catch(e) {} });
    markersRef.current = [];
    const r = await fetch('/api/geo/map');
    const d = await r.json();
    setData(d);
    const L = window.L;
    if (!L || !mapRef.current) return;
    if (leafletMap.current) { leafletMap.current.off(); leafletMap.current.eachLayer(l => leafletMap.current.removeLayer(l)); }
    else {
      leafletMap.current = L.map(mapRef.current, { zoomControl: true }).setView([20, 10], 2);
    }
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png', { attribution: '' }).addTo(leafletMap.current);
    leafletMap.current.on('click', (e) => handleClick(e, d));
  };

  const handleClick = (e, d) => {
    if (!d) return;
    const L = window.L;
    const dist = haversine(e.latlng.lat, e.latlng.lng, d.lat, d.lng);
    const p = dist <= 100 ? 5 : dist <= 1000 ? 1 : -1;
    setDistance(Math.round(dist));
    setPts(p);
    setClicked(true);
    if (p > 0) onCorrect(p);
    const m1 = L.marker([e.latlng.lat, e.latlng.lng]).addTo(leafletMap.current).bindPopup('Dit gæt').openPopup();
    const m2 = L.circleMarker([d.lat, d.lng], { color: '#00f5a0', fillColor: '#00f5a0', fillOpacity: 1, radius: 10 }).addTo(leafletMap.current).bindPopup(d.country);
    markersRef.current = [m1, m2];
    leafletMap.current.off('click');
  };

  return (
    <>
      <div style={{ fontFamily: 'Bangers, cursive', fontSize: '3.5rem', color: 'var(--green)', letterSpacing: '3px', textShadow: '0 0 20px rgba(0,245,160,0.4)' }}>
        {data ? data.country : 'Henter...'}
      </div>
      {!clicked && <div style={{ color: 'var(--text-muted)', fontWeight: 700 }}>👆 Klik på kortet hvor landet er!</div>}
      <div ref={mapRef} style={{ width: '100%', height: '650px', borderRadius: '16px', overflow: 'hidden', border: '2px solid rgba(0,245,160,0.2)' }} />
      {distance !== null && (
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '0.75rem', alignItems: 'center' }}>
          <div style={{ fontFamily: 'Bangers, cursive', fontSize: '1.6rem', letterSpacing: '2px', color: pts >= 5 ? 'var(--green)' : pts === 1 ? 'var(--accent)' : 'var(--red)', textShadow: pts >= 5 ? '0 0 15px rgba(0,245,160,0.5)' : 'none' }}>
            {distance < 1000 ? distance+' km væk' : (distance/1000).toFixed(1)+'k km væk'} — {pts >= 5 ? '🎯 +5 XP!' : pts === 1 ? '👍 +1 XP' : '📍 -1 XP'}
          </div>
          <button style={s.nextBtn} onClick={loadNew}>Næste land →</button>
        </div>
      )}
    </>
  );
}

export default function Geografi({ user, name, age }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('flag');
  const [xp, setXp] = useState({ today: 0, week: 0, year: 0 });
  const [showXpFloat, setShowXpFloat] = useState(false);
  const [xpGained, setXpGained] = useState(0);

  useEffect(() => {
    fetch('/api/xp/'+user).then(r => r.json()).then(d => setXp(d.geografi || { today: 0, week: 0, year: 0 })).catch(() => {});
  }, [user]);

  const addXP = async (pts) => {
    await fetch('/api/xp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user, subject: 'geografi', points: pts }) });
    setXp(prev => ({ today: prev.today+pts, week: prev.week+pts, year: prev.year+pts }));
    setXpGained(pts);
    setShowXpFloat(true);
    setTimeout(() => setShowXpFloat(false), 1000);
  };

  return (
    <div style={s.page}>
      {showXpFloat && <div style={s.xpFloat}>+{xpGained} XP 🌍</div>}
      <div style={s.header}>
        <button style={s.back} onClick={() => navigate('/'+user)}>← Tilbage</button>
        <h1 style={{ fontFamily: 'Bangers, cursive', fontSize: '2rem', letterSpacing: '3px', color: 'var(--green)', flex: 1, textShadow: '0 0 15px rgba(0,245,160,0.5)' }}>🌍 Geografi</h1>
      </div>
      <div style={s.xpRow}>
        <span>I dag: <strong style={{ color: 'var(--green)' }}>{xp.today} XP</strong></span>
        <span>Uge: <strong style={{ color: 'var(--green)' }}>{xp.week} XP</strong></span>
        <span>År: <strong style={{ color: 'var(--green)' }}>{xp.year} XP</strong></span>
      </div>
      <div style={s.tabs}>
        {[['flag', '🚩 Flag'], ['kort', '🗺️ Kort'], ['hovedstaeder', '🏛️ Hovedstæder']].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ background: tab === key ? 'var(--green)' : 'transparent', color: tab === key ? '#060b14' : 'var(--text-muted)', border: 'none', borderRadius: '12px', padding: '0.6rem 1.2rem', fontSize: '0.95rem', fontWeight: 800, cursor: 'pointer', transition: 'all 0.2s' }}>{label}</button>
        ))}
      </div>
      <div style={s.card}>
        {tab === 'flag' && <FlagMode key="flag" onCorrect={addXP} />}
        {tab === 'kort' && <MapMode key="kort" onCorrect={addXP} />}
        {tab === 'hovedstaeder' && <CapitalMode key="hoved" onCorrect={addXP} />}
      </div>
    </div>
  );
}
